module.exports = __webpack_public_path__ + "img/js-logo-big.a340a3c3.png";